<template>
    <div class="key-data-qualification-base-info">
        <div class="content">
            <el-row>
                <el-col class="has-bg right-text" :span="2">供应商编码</el-col>
                <el-col :span="4">{{ formData.supplierCode }}</el-col>
                <el-col class="has-bg right-text" :span="2">供应商名称</el-col>
                <el-col :span="4">{{ formData.supplierName }}</el-col>
                <el-col class="has-bg right-text" :span="2"><span class="required">*</span>公司信誉度</el-col>
                <el-col :span="4"><MSelect :class="errorItems.companyLevel ? 'is-error' : ''" :optionNum="'COMPANY_LEVEL'" :value="formData.companyLevel" @input="handleXydfSelect"></MSelect></el-col>
                <el-col class="has-bg right-text" :span="2"><span class="required">*</span>企业性质</el-col>
                <el-col :span="4">
                    <span v-if="pdfTransforming">{{ formData.businessNature }}</span>
                    <el-input v-else :class="errorItems.businessNature ? 'is-error' : ''" v-model.trim="formData.businessNature" />
                </el-col>
            </el-row>
            <el-row>
                <el-col class="has-bg right-text" :span="2">法人代表</el-col>
                <el-col :span="4">{{ formData.corporateName }}</el-col>
                <el-col class="has-bg right-text" :span="2">法人身份证号</el-col>
                <el-col :span="4">{{ formData.idCard }}</el-col>
                <el-col class="has-bg right-text" :span="2">注册地址</el-col>
                <el-col :span="4">{{ formData.address }}</el-col>
                <el-col class="has-bg right-text" :span="2">注册资金</el-col>
                <el-col :span="4">{{ formData.registerCapital }}</el-col>
            </el-row>
            <el-row>
                <el-col class="has-bg right-text" :span="2">公司成立时间</el-col>
                <el-col :span="4">{{ formData.registerDate }}</el-col>
                <el-col class="has-bg right-text" :span="2"><span class="required">*</span>{{type === 'lessThan' ? '通讯地址' : ''}}邮编</el-col>
                <el-col :span="4">
                    <span v-if="pdfTransforming">{{ formData.postalCode }}</span>
                    <el-input v-else :class="errorItems.postalCode ? 'is-error' : ''" v-model.trim="formData.postalCode" />
                </el-col>
                <el-col class="has-bg right-text" :span="2"><span class="required">*</span>公司传真</el-col>
                <el-col :span="4">
                    <span v-if="pdfTransforming">{{ formData.faxNumber }}</span>
                    <el-input v-else :class="errorItems.faxNumber ? 'is-error' : ''" v-model.trim="formData.faxNumber" />
                </el-col>
                <el-col class="has-bg right-text" :span="2">
                    <template v-if="type === 'warehouse'"><span class="required">*</span>公司邮箱</template>
                </el-col>
                <el-col :span="4">
                    <template v-if="type === 'warehouse'">
                        <span v-if="pdfTransforming">{{ formData.email }}</span>
                        <el-input v-else :class="errorItems.email ? 'is-error' : ''" v-model.trim="formData.email" />
                    </template>
                </el-col>
            </el-row>
            <el-row>
                <el-col class="has-bg right-text" :span="2"><span class="required">*</span>通讯地址</el-col>
                <el-col :span="22">
                    <span v-if="pdfTransforming">{{ formData.contactAddress }}</span>
                    <el-input v-else :class="errorItems.contactAddress ? 'is-error' : ''" v-model.trim="formData.contactAddress" />
                </el-col>
            </el-row>
            <el-row>
                <el-col class="has-bg right-text" :span="2"><span class="required">*</span>总经理</el-col>
                <el-col :span="4">
                    <span v-if="pdfTransforming">{{ formData.generalManager }}</span>
                    <el-input v-else :class="errorItems.generalManager ? 'is-error' : ''" v-model.trim="formData.generalManager" />
                </el-col>
                <el-col class="has-bg right-text" :span="2"><span class="required">*</span>联系人姓名</el-col>
                <el-col :span="4">
                    <span v-if="pdfTransforming">{{ formData.contacts }}</span>
                    <el-input v-else :class="errorItems.contacts ? 'is-error' : ''" v-model.trim="formData.contacts" />
                </el-col>
                <el-col class="has-bg right-text" :span="2"><span class="required">*</span>联系人电话</el-col>
                <el-col :span="4">
                    <span v-if="pdfTransforming">{{ formData.contactsMobile }}</span>
                    <el-input v-else :class="errorItems.contactsMobile ? 'is-error' : ''" v-model.trim="formData.contactsMobile" />
                </el-col>
                <el-col class="has-bg right-text" :span="2"><span class="required">*</span>联系人职务</el-col>
                <el-col :span="4">
                    <span v-if="pdfTransforming">{{ formData.contactTitle }}</span>
                    <el-input v-else :class="errorItems.contactTitle ? 'is-error' : ''" v-model.trim="formData.contactTitle" />
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
import dayjs from 'dayjs'
import MSelect from '@/components/lots/otpSelect2';

const INIT_FORM = {
    supplierCode: '',
    supplierName: '',
    companyLevel: '',
    businessNature: '',
    corporateName: '',
    idCard: '',
    address: '',
    registerCapital: '',
    registerDate: '',
    contactAddress: '',
    postalCode: '',
    faxNumber: '',
    generalManager: '',
    contacts: '',
    contactsMobile: '',
    contactTitle: '',
    email: '',
}

export default {
    components: { MSelect },
    props: {
        pdfTransforming: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            formData: {
                ...INIT_FORM
            },
        };
    },
    computed: {
        errorItems() {
            const items = {
                companyLevel: false,
                businessNature: false,
                contactAddress: false,
                postalCode: false,
                faxNumber: false,
                generalManager: false,
                contacts: false,
                contactsMobile: false,
                contactTitle: false,
            }
            if(this.type === 'warehouse'){
                items.email = false
            }
            Object.keys(items).forEach(key => {
                if (key === 'companyLevel') {
                    items[key] = ['', null, undefined].includes(this.formData[key])
                } else if (key === 'contactAddress') {
                    items[key] = ['', null, undefined].includes(this.formData[key]) || this.formData[key].length > 100
                } else if (key === 'postalCode') {
                    items[key] = ['', null, undefined].includes(this.formData[key]) || this.formData[key].length > 20 || !/^\d+$/.test(this.formData[key])
                } else {
                    items[key] = ['', null, undefined].includes(this.formData[key]) || this.formData[key].length > 20
                }
            })
            return items
        },
    },
    methods: {
        handleXydfSelect(val) {
            this.formData.companyLevel = val
        },
        setBaseInfo(data) {
            this.formData.supplierCode = data.supplierCode ||  ''
            this.formData.supplierName = data.supplierName ||  ''
            this.formData.corporateName = data.corporateName ||  ''
            this.formData.idCard = data.idCard ||  ''
            this.formData.address = data.address ||  ''
            this.formData.registerCapital = data.registerCapital ||  ''
            this.formData.registerDate = data.registerDate ||  ''
            this.formData.contacts = data.contacts ||  ''
            this.formData.contactsMobile = data.contactsMobile ||  ''
        },
        setFormData(data) {
            this.formData.companyLevel = data.companyLevel || ''
            this.formData.businessNature = data.businessNature ||  ''
            this.formData.contactAddress = data.contactAddress ||  ''
            this.formData.postalCode = data.postalCode || ''
            this.formData.faxNumber = data.faxNumber || ''
            this.formData.generalManager = data.generalManager || ''
            this.formData.contactTitle = data.contactTitle || ''
            this.formData.email = data.email || ''
            if (data.contacts) {
                this.formData.contacts = data.contacts
            }
            if (data.contactsMobile) {
                this.formData.contactsMobile = data.contactsMobile
            }
        },
        getData() {
            const isError = Object.entries(this.errorItems).some(item => item[1])
            if (isError) {
                return false
            } else {
                return { ...this.formData }
            }
        },
        reset() {
            this.formData = { ...INIT_FORM }
        },
        timeformat(time) {
            return time ? dayjs(time).format('YYYY-MM-DD') : ''
        },
    },
    mounted() {},
};
</script>
<style lang="less">
.key-data-qualification-base-info {
    margin-bottom: 20px;
    font-size: 14px;
    color: #000;

    .content {
        border-top: 1px solid #ddd;
        border-left: 1px solid #ddd;
    }

    .has-bg {
        background: #f5f7fa;
    }

    .right-text {
        text-align: right;
    }

    .el-row {
        display: flex;
        width: 100%;
    }

    .el-col {
        float: none;
        padding: 5px;
        min-height: 30px;
        border-right: 1px solid #ddd;
        border-bottom: 1px solid #ddd;
    }


    // .wrap-label-row .el-col {
    //     min-height: 50px;
    // }

    // .no-wrap {
    //     white-space: nowrap;
    // }

    // .preview-btn {
    //     padding: 0;
    // }
}
</style>
